import { getMessage } from '../../../utils/messageUtils'
import { AlertTime } from '../../../utils/recipeUtils'

import './RecipeMain.scss'
import NumericInput from '../../PopupForm/NumericInput'
import AlertInput from '../../PopupForm/AlertInput'
import type { User } from '../../../utils/loginUtils'

interface RecipeMainProps {
  name: string
  setName: (name: string) => void
  type: string
  setType: (type: string) => void
  time: number
  setTime: (time: number) => void
  tuppers: number
  setTuppers: (tuppers: number) => void
  alert: string
  setAlert: (alert: string) => void
  alertTime: AlertTime | null
  setAlertTime: (alertTime: AlertTime) => void
  desayuno: boolean
  setDesayuno: (desayuno: boolean) => void
  almuerzo: boolean
  setAlmuerzo: (almuerzo: boolean) => void
  comida: boolean
  setComida: (comida: boolean) => void
  merienda: boolean
  setMerienda: (merienda: boolean) => void
  cena: boolean
  setCena: (cena: boolean) => void
  currentTypes: string[]
  isMobile: boolean
  user: User
}

function RecipeMain({
  name,
  setName,
  type,
  setType,
  time,
  setTime,
  tuppers,
  setTuppers,
  alert,
  setAlert,
  alertTime,
  setAlertTime,
  desayuno,
  setDesayuno,
  almuerzo,
  setAlmuerzo,
  comida,
  setComida,
  merienda,
  setMerienda,
  cena,
  setCena,
  currentTypes,
  isMobile,
  user,
}: RecipeMainProps) {
  const labelClass = `pop-up-form-label ${isMobile ? 'pop-up-form-label-mobile' : ''}`
  const fieldClass = `pop-up-form-field ${isMobile ? 'pop-up-form-field-mobile' : ''}`

  return (
    <div
      className={`pop-up-form recipe-pop-up-main-content ${isMobile ? 'pop-up-form-mobile recipe-pop-up-main-content-mobile' : ''}`}
    >
      <div className="pop-up-form-row">
        <span className={labelClass}>{getMessage('name')}:</span>
        <input
          className={fieldClass}
          type="text"
          placeholder={getMessage('recipe_name')}
          value={name}
          onChange={e => setName(e.target.value)}
        />
      </div>
      <div className="pop-up-form-row">
        <span className={labelClass}>{getMessage('type')}:</span>
        <input
          className={fieldClass}
          type="text"
          placeholder={getMessage('recipe_type')}
          value={type}
          onChange={e => setType(e.target.value)}
          list="recipe-types"
        />
        <datalist id="recipe-types">
          {currentTypes.map((typeOption, index) => (
            <option key={index} value={typeOption} />
          ))}
        </datalist>
      </div>
      <div className="pop-up-form-row">
        <span className={labelClass}>{getMessage('time')}:</span>
        <input
          className={fieldClass}
          type="number"
          min="0"
          placeholder={getMessage('recipe_time')}
          value={time}
          onChange={e => setTime(Number(e.target.value))}
        />
        <datalist id="recipe-types">
          {currentTypes.map((typeOption, index) => (
            <option key={index} value={typeOption} />
          ))}
        </datalist>
      </div>
      <NumericInput
        className={labelClass}
        label={getMessage('tuppers_generated')}
        value={tuppers}
        setValue={setTuppers}
        isMobile={isMobile}
      />
      <AlertInput
        user={user}
        alert={alert}
        setAlert={setAlert}
        alertTime={alertTime}
        setAlertTime={setAlertTime}
        isMobile={isMobile}
      />
      <div className="pop-up-form-checks">
        <div
          className={`pop-up-form-row pop-up-form-checks-row ${isMobile ? 'pop-up-form-checks-row-mobile' : ''}`}
        >
          <label className={labelClass}>
            <input
              className="pop-up-form-checkbox"
              type="checkbox"
              checked={desayuno}
              onChange={e => setDesayuno(e.target.checked)}
            />{' '}
            {getMessage('breakfast')}
          </label>
          <label className={labelClass}>
            <input
              className="pop-up-form-checkbox"
              type="checkbox"
              checked={almuerzo}
              onChange={e => setAlmuerzo(e.target.checked)}
            />{' '}
            {getMessage('almuerzo')}
          </label>
          <label className={labelClass}>
            <input
              className="pop-up-form-checkbox"
              type="checkbox"
              checked={comida}
              onChange={e => setComida(e.target.checked)}
            />{' '}
            {getMessage('lunch')}
          </label>
          <label className={labelClass}>
            <input
              className="pop-up-form-checkbox"
              type="checkbox"
              checked={merienda}
              onChange={e => setMerienda(e.target.checked)}
            />{' '}
            {getMessage('merienda')}
          </label>
          <label className={labelClass}>
            <input
              className="pop-up-form-checkbox"
              type="checkbox"
              checked={cena}
              onChange={e => setCena(e.target.checked)}
            />{' '}
            {getMessage('dinner')}
          </label>
        </div>
      </div>
    </div>
  )
}

export default RecipeMain
